<form [formGroup]="playImporterForm" (ngSubmit)="onSave()">
    <div class="file-import-container">
        <div class="file-import-instructions-container">
            <r1-compass-lib-instructions headerText="File Import">
                To import records, drag a file to the drop area or click to upload a file. A file preview will be
                automatically generated. Please note, your file must be either CSV or TXT format, UTF-8 encoded,
                comma-delimited, and contain a header row. More information on list uploads can be found in the User
                Guide.
            </r1-compass-lib-instructions>
        </div>
        <div class="file-dropzone-container">
            <r1-compass-app-file-dropzone
                [file]="file"
                (download)="onDownload()"
                (fileAdded)="onFileAdded($event)"
                (fileRemoved)="onFileRemoved()" />
        </div>
        <div class="file-preview-container">
            <r1-compass-app-file-preview [uploadedFilePreview]="uploadedFilePreview" />
        </div>
    </div>
    <r1-compass-lib-divider />
    <div class="field-mapping-container">
        <div class="field-mapping-instructions-container">
            <r1-compass-lib-instructions headerText="Field Mapping">
                Add rows below by clicking '+Add' to map fields to Salesforce Play and/or Recommendation object fields,
                then select the Salesforce object and field it should map to.
            </r1-compass-lib-instructions>
        </div>
        <div class="field-mapping-list-container">
            @for (mappingRowFormGroup of playImporterForm.controls.customFileMapping.controls; track $index) {
                <r1-compass-app-file-mapping-row
                    [rowIndex]="$index"
                    [rowFormGroup]="mappingRowFormGroup"
                    [csvHeaders]="csvHeaders"
                    [playFields]="playFields"
                    [recommendationFields]="recommendationFields()"
                    [salesforceUniqueRecommendationFieldTargetOption]="
                        salesforceUniqueRecommendationFieldTargetOption()
                    "
                    [existingMappedFields]="playImporterForm.controls.customFileMapping"
                    (deleteFileMappingRow)="onDeleteFileMappingRow($index)"
                    (sourceFieldNameSelected)="onSourceFieldSelected($event)" />
            }
        </div>
        <div class="field-mapping-footer">
            <button mat-raised-button color="primary" (click)="onAddFieldMapping()" type="button">+Add</button>
        </div>
    </div>
    <div class="play-importer-footer">
        <button mat-raised-button color="primary" [disabled]="disableSave()" type="submit">Save</button>
    </div>
</form>
